var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-border tw-rounded-2xl lg:tw-rounded-2.5xl tw-px-3 tw-py-4 lg:tw-px-4 lg:tw-py-5"},[_c('div',{staticClass:"tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-2 lg:tw-gap-4 tw-h-full"},[_vm._t("image"),_vm._t("title"),_vm._t("description"),_vm._t("price"),_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }